/**
 * 全局消息工具 - 使用 Antd App context
 * 解决静态方法无法消费 context 的问题
 */

import { App } from 'antd';

type MessageApi = NonNullable<ReturnType<typeof App.useApp>['message']>;

let messageApi: MessageApi | null = null;

export const setMessageApi = (api: MessageApi) => {
  messageApi = api;
};

export const getMessageApi = () => messageApi;

function forward<K extends keyof MessageApi>(key: K) {
  return (...args: Parameters<MessageApi[K]>) => {
    const api = messageApi;
    if (!api) {
      console.warn('Message API not initialized. Make sure to call setMessageApi in App component.');
      return undefined as ReturnType<MessageApi[K]>;
    }
    const fn = api[key] as unknown;
    if (typeof fn !== 'function') {
      return undefined as ReturnType<MessageApi[K]>;
    }
    return (fn as (...a: unknown[]) => unknown)(...(args as unknown as unknown[])) as ReturnType<MessageApi[K]>;
  };
}

/** 与 App.useApp().message 一致，支持字符串或 ArgsProps（如 key、content） */
export const message = {
  success: forward('success'),
  error: forward('error'),
  warning: forward('warning'),
  info: forward('info'),
  loading: forward('loading'),
  open: forward('open'),
  destroy: forward('destroy'),
};
